import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Icon, IconArrowLeft } from '@flixbus/honeycomb-icons-react';
import { Button } from '@flixbus/honeycomb-react';

import { useVoucherFormContext } from '../Context';
import { generateMultipleVouchers, generateVoucher, saveComment } from '../../../apis';

import styles from './voucher-form-submit.module.scss';
import { useNotification } from '../../Notifications/Context';

const VoucherFormSubmit = () => {
  const { pushToast } = useNotification();
  const {
    formState: { payload, activeDiscount, comment },
    formErrors,
  } = useVoucherFormContext();
  const navigate = useNavigate();
  const { count } = payload;

  const handleSubmit = async () => {
    if (Object.keys(formErrors).length > 0) {
      pushToast({
        message: Object.values(formErrors)[0],
        status: 'warning',
      });
      return;
    }

    if (
      ['credit_amount', 'value_marketing', 'value_hybrid'].includes(activeDiscount) &&
      payload.discountType.currency &&
      payload.discountType.currency === 'MXN' &&
      !payload.entity
    ) {
      pushToast({
        message: 'Please select a contract!',
        status: 'warning',
      });
      return;
    }

    try {
      const res =
        count === 1 ? await generateVoucher(payload) : await generateMultipleVouchers(payload);

      if (comment && comment.length > 0) {
        try {
          count === 1 && (await saveComment(res.id, { comment: comment }));
        } catch (e) {
          const message = e instanceof Error ? e.message : 'An unknown error occurred';

          pushToast({
            message,
            status: 'danger',
          });
        }
      }

      count === 1
        ? navigate(`/success/${res.id}`, { state: { voucher: res } })
        : navigate(`/batch/${res.id}`);
    } catch (e) {
      const message = e instanceof Error ? e.message : 'An unknown error occurred';
      const detail = JSON.parse(message)?.detail || message;

      pushToast({
        message: detail,
        status: 'danger',
      });
    }
  };

  return (
    <div className={styles.container}>
      <Button Elem='a' appearance='link' RouterLink={Link} to='/'>
        <Icon InlineIcon={IconArrowLeft} />
        Cancel
      </Button>
      <Button
        size='md'
        appearance='primary'
        type='submit'
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        Confirm voucher creation
      </Button>
    </div>
  );
};

export default VoucherFormSubmit;
